<div class="ghost-panel-row">
    <mat-card appearance="outlined" class="ghost-panel-card mat-elevation-z0">
        <mat-card-title *ngIf="panelTitle">Title</mat-card-title>
        <mat-card-content class="ghost-panel-card-content" style="color: #222222; display: flex;" fxLayoutAlign="space-between center">
            <ng-template dynamicComponent></ng-template>
        </mat-card-content>
    </mat-card>
</div>